import { useState, useEffect, useRef } from 'react'
import throttle from 'lodash/throttle'

export const useActiveAnchor = (anchors: string[], extraOffset = 0) => {
  const [activeAnchor, setActiveAnchor] = useState(anchors[0])
  const offset = useRef(0)

  const getNavHeight = () =>
    parseInt(
      window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--mc-scale-10')
        .replace('rem', ''),
      10,
    ) * parseFloat(getComputedStyle(document.documentElement).fontSize)

  useEffect(() => {
    offset.current = getNavHeight() * 2 + extraOffset
  }, [offset, extraOffset])

  const calcScrollPosition = (position: DOMRect) =>
    Math.floor(position.y - offset.current)

  const getElementPosition = (anchor: string): DOMRect | undefined =>
    document.querySelector(`#${anchor}`)?.getBoundingClientRect()

  const updateActiveAnchor = () => {
    let newActiveAnchor = anchors[0]
    anchors.forEach((anchor) => {
      const position = getElementPosition(anchor)

      if (position && calcScrollPosition(position) <= 0) {
        newActiveAnchor = anchor
      }
    })

    setActiveAnchor(newActiveAnchor)
  }

  useEffect(() => {
    updateActiveAnchor()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchors])

  const handleScroll = throttle(() => {
    updateActiveAnchor()
  }, 50)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll, extraOffset])

  return { activeAnchor }
}
